import { PropsWithChildren, useEffect, useState } from 'react';
import { AxiosError } from 'axios';
import useApplicationStore from '@my-pages/stores/useApplicationStore.tsx';
import FullScreenLoader from '@shared/components/FullScreenLoader.tsx';

const AuthenticationProvider = ({ children }: PropsWithChildren) => {
    const [isLoading, setIsLoading] = useState(true);
    const setAuthenticationError = useApplicationStore((state) => state.setAuthenticationError);
    const tryGetUser = useApplicationStore((state) => state.tryGetUser);

    useEffect(() => {
        setIsLoading(true);
        tryGetUser()
            .catch((error: AxiosError) => {
                setAuthenticationError(error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    return isLoading ? <FullScreenLoader /> : <>{children}</>;
};
export default AuthenticationProvider;
